import React, { createContext, useContext, useState } from 'react';

const SharedStateContext = createContext();
const NewYearModalContext = createContext();

export function SharedStateProvider({ children }) {  
  const [isBugReportModalOpen, setIsBugReportModalOpen] = useState(false);

  return (
    <SharedStateContext.Provider value={{ 
      isBugReportModalOpen, 
      setIsBugReportModalOpen 
    }}>
      <NewYearModalProvider>
        {children}
      </NewYearModalProvider>
    </SharedStateContext.Provider>
  );
}

export function NewYearModalProvider({ children }) {
  const [currentScreen, setCurrentScreen] = useState(1);
  const [currentDataTab, setCurrentDataTab] = useState("");
  const [selectedDataCategories, setSelectedDataCategories] = useState(['courses', 'teachers', 'classrooms', 'departments', 'sections', 'section_placements', 'users']);
  const [categoryData, setCategoryData] = useState({});
  const [disabledCategoryDataIds, setDisabledCategoryDataIds] = useState({});
  const [categoryDataSelection, setCategoryDataSelection] = useState({});
  const [constraints, setConstraints] = useState([]);
  const [checkedConstraints, setCheckedConstraints] = useState([]);

  return (
    <NewYearModalContext.Provider value={{ 
      currentScreen, 
      setCurrentScreen,
      currentDataTab,
      setCurrentDataTab,
      selectedDataCategories,
      setSelectedDataCategories,
      categoryData,
      setCategoryData,
      disabledCategoryDataIds,
      setDisabledCategoryDataIds,
      categoryDataSelection,
      setCategoryDataSelection,
      constraints,
      setConstraints,
      checkedConstraints,
      setCheckedConstraints
    }}>
      {children}
    </NewYearModalContext.Provider>
  );
}

export function useSharedState() {
  return useContext(SharedStateContext);
}
export function useNewYearModalContext() {
  return useContext(NewYearModalContext);
}